// Styles
import './_main-product-v2.scss';
import 'blocks/radial-dials';
var getThemeEditorBlock = (event, dataAttribute) => {
  var target = event.target;
  if (target && typeof target.hasAttribute === 'function' && target.hasAttribute(dataAttribute)) {
    return target;
  }
  var blockId = event.detail && event.detail.blockId;
  if (!blockId) {
    return null;
  }
  return document.querySelector("[".concat(dataAttribute, "=\"").concat(blockId, "\"]"));
};
var toggleThemeEditorBlockSelection = (event, dataAttribute, isSelected) => {
  var block = getThemeEditorBlock(event, dataAttribute);
  if (block) {
    block.classList.toggle('is-selected', isSelected);
  }
};
var registerBazaarvoiceReviewLine = function registerBazaarvoiceReviewLine() {
  var BV = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.BV;
  if (!document.querySelector('[data-review-line]')) return;
  if (!BV || typeof BV.registerMutationObserver !== 'function') return;
  BV.registerMutationObserver();
};
var onBazaarvoiceReady = () => {
  registerBazaarvoiceReviewLine();
  var previousCallback = window.bvCallback;
  window.bvCallback = function bazaarvoiceCallback(BV) {
    if (typeof previousCallback === 'function') {
      previousCallback.call(this, BV);
    }
    registerBazaarvoiceReviewLine(BV);
  };
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onBazaarvoiceReady);
} else {
  onBazaarvoiceReady();
}
document.addEventListener('shopify:section:load', () => {
  registerBazaarvoiceReviewLine();
});
document.addEventListener('shopify:block:select', event => {
  toggleThemeEditorBlockSelection(event, 'data-product-text', true);
  toggleThemeEditorBlockSelection(event, 'data-icon-text', true);
  toggleThemeEditorBlockSelection(event, 'data-product-image', true);
});
document.addEventListener('shopify:block:deselect', event => {
  toggleThemeEditorBlockSelection(event, 'data-product-text', false);
  toggleThemeEditorBlockSelection(event, 'data-icon-text', false);
  toggleThemeEditorBlockSelection(event, 'data-product-image', false);
});